<p-dialog
  [header]="headerTitle()"
  [(visible)]="visible"
  appendTo="body"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: 'min(560px, 95vw)' }"
  styleClass="unit-edit-dialog"
  (onHide)="onCancel()">

  <!-- ── Instruction message ──────────────────────────────────────── -->
  <p class="text-sm leading-6 text-[--text-secondary] mb-5">{{ message() }}</p>

  <!-- ── Dynamic form ─────────────────────────────────────────────── -->
  <form [formGroup]="form()" (ngSubmit)="onSave()" novalidate>

    <div class="grid grid-cols-1 gap-4 pt-3 sm:grid-cols-2">

      @for (spec of fieldSpecs(); track spec.key) {

        <div class="flex flex-col gap-1" [class.sm:col-span-2]="fieldType(spec) === 'textarea'">

          <!-- ── State dropdown (code table) ─────────────────────── -->
          @if (fieldType(spec) === 'state') {
            <p-floatLabel variant="on">
              <p-select
                [inputId]="spec.key"
                [formControlName]="spec.key"
                [options]="optionsFor(spec)"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                filterBy="label"
                appendTo="body"
                placeholder=" "
                styleClass="w-full"
                [class.ng-invalid]="hasError(spec.key)"
                [class.ng-dirty]="hasError(spec.key)"
                (onChange)="onStateChange(spec.key)" />
              <label [for]="spec.key">{{ spec.label }} *</label>
            </p-floatLabel>
          }

          <!-- ── Dropdown (p-select with static/dynamic options) ── -->
          @else if (fieldType(spec) === 'select') {
            <p-floatLabel variant="on">
              <p-select
                [inputId]="spec.key"
                [formControlName]="spec.key"
                [options]="optionsFor(spec)"
                optionLabel="label"
                optionValue="value"
                [filter]="showFilter(spec)"
                filterBy="label"
                appendTo="body"
                placeholder=" "
                styleClass="w-full"
                [class.ng-invalid]="hasError(spec.key)"
                [class.ng-dirty]="hasError(spec.key)" />
              <label [for]="spec.key">{{ spec.label }} *</label>
            </p-floatLabel>
          }

          <!-- ── City autocomplete (state-dependent code table) ─── -->
          @else if (fieldType(spec) === 'city') {
            <p-floatLabel variant="on">
              <p-autocomplete
                [inputId]="spec.key"
                [formControlName]="spec.key"
                styleClass="w-full"
                inputStyleClass="w-full"
                [suggestions]="cityOptions()"
                (completeMethod)="onCitySearch(spec, $event.query)"
                (onSelect)="onCitySelect(spec, $event.value)"
                [dropdown]="true"
                appendTo="body"
                [class.ng-invalid]="hasError(spec.key)"
                [class.ng-dirty]="hasError(spec.key)" />
              <label [for]="spec.key">{{ spec.label }} *</label>
            </p-floatLabel>
          }

          <!-- ── Zip autocomplete (state/city-dependent code table) ─ -->
          @else if (fieldType(spec) === 'zip') {
            <p-floatLabel variant="on">
              <p-autocomplete
                [inputId]="spec.key"
                [formControlName]="spec.key"
                styleClass="w-full"
                inputStyleClass="w-full"
                [suggestions]="zipOptions()"
                (completeMethod)="onZipSearch(spec, $event.query)"
                [dropdown]="true"
                [maxlength]="5"
                appendTo="body"
                [class.ng-invalid]="hasError(spec.key)"
                [class.ng-dirty]="hasError(spec.key)" />
              <label [for]="spec.key">{{ spec.label }} *</label>
            </p-floatLabel>
          }

          <!-- ── Address autocomplete (Google Places) ───────────── -->
          @else if (fieldType(spec) === 'address') {
            <p-floatLabel variant="on">
              <p-autocomplete
                [inputId]="spec.key"
                [formControlName]="spec.key"
                styleClass="w-full"
                inputStyleClass="w-full"
                [suggestions]="addressSuggestions()"
                (completeMethod)="onAddressSearch($event)"
                (onSelect)="onAddressSelect($event, spec)"
                [forceSelection]="false"
                [minLength]="3"
                appendTo="body"
                [class.ng-invalid]="hasError(spec.key)"
                [class.ng-dirty]="hasError(spec.key)" />
              <label [for]="spec.key">{{ spec.label }} *</label>
            </p-floatLabel>
          }

          <!-- ── Auto-resizing textarea ──────────────────────────── -->
          @else if (fieldType(spec) === 'textarea') {
            <p-floatLabel variant="on">
              <textarea
                pTextarea
                [id]="spec.key"
                [formControlName]="spec.key"
                rows="3"
                [autoResize]="true"
                placeholder=" "
                class="w-full resize-none"
                [class.ng-invalid]="hasError(spec.key)"
                [class.ng-dirty]="hasError(spec.key)"></textarea>
              <label [for]="spec.key">{{ spec.label }} *</label>
            </p-floatLabel>
          }

          <!-- ── Plain text input (default) ──────────────────────── -->
          @else {
            <p-floatLabel variant="on">
              <input
                pInputText
                [id]="spec.key"
                [formControlName]="spec.key"
                autocomplete="off"
                class="w-full"
                [class.ng-invalid]="hasError(spec.key)"
                [class.ng-dirty]="hasError(spec.key)" />
              <label [for]="spec.key">{{ spec.label }} *</label>
            </p-floatLabel>
          }

          <!-- ── Per-field inline validation message ─────────────── -->
          @if (hasError(spec.key)) {
            <small class="text-red-500 text-xs">{{ errorMessage(spec) }}</small>
          }

        </div>

      }

    </div>

  </form>

  <!-- ── Footer ────────────────────────────────────────────────────── -->
  <ng-template #footer>
    <p-button
      label="Cancel"
      [text]="true"
      severity="secondary"
      (onClick)="onCancel()" />
    <p-button
      [label]="submitLabel()"
      [loading]="saving()"
      [disabled]="saving()"
      (onClick)="onSave()" />
  </ng-template>

</p-dialog>
